export class AddressService {

    constructor() { }

    public getDefault(addressList: Array<qpmn.user.model.domain.address.IAddress>): qpmn.user.model.domain.address.IAddress | undefined {
        return addressList.find((addressItem) => {
            return addressItem.isDefault
        })
    }
}